import React, { useEffect, useMemo, useRef, useState } from "react";
import "./Services.css";

// ✅ feature icons
import icon1 from "../assets/icon.png";
import icon2 from "../assets/icon-2.png";
import icon3 from "../assets/icon-3.png";

// ✅ hero image
import servicesImg from "../assets/ready.png";



// ✅ favicon below stats caption
import faviconIbs from "../assets/favicon-ibs.png";

// ✅ Construction Services gallery images (right side)
import generalImg from "../assets/general.png";
import constructionImg from "../assets/construction.png";
import metalImg from "../assets/metal.png";
import houseImg from "../assets/house.png";
import greenImg from "../assets/green.png";

export default function Services() {
  const provideServices = useMemo(
    () => [
      {
        title: "Infrastructure",
        desc: "Strong foundations, smarter futures. We build roads, drains, utilities, and everything in between reliable, efficient, and built to last.",
        icon: icon2,
      },
      {
        title: "Construction & Development",
        desc: "We bring ideas to life from groundbreaking to finishing touches. Quality-driven construction and smart development for lasting impact.",
        icon: icon1,
      },
      {
        title: "Engineering",
        desc: "Precision meets innovation. We design smart, sustainable solutions that turn blueprints into reality.",
        icon: icon1,
      },
      {
        title: "Project Management",
        desc: "On time, on budget, stress-free. We handle every stage of your project with expert coordination and clear communication.",
        icon: icon1,
      },
      {
        title: "Roads & Bridges",
        desc: "Connecting places with precision. We build strong, safe, and lasting roads and bridges that stand the test of time.",
        icon: icon3,
      },
      {
        title: "Urban Planning",
        desc: "Shaping smarter cities. We design organized, efficient, and sustainable spaces for modern urban living.",
        icon: icon1,
      },
    ],
    []
  );



  return (
    <section className="servicesPage">
      {/* =========================
          SECTION 1: FEATURES GRID
         ========================= */}
      <div className="servicesSectionOne">
        <div className="servicesInner">
          <h1 className="servicesTitle">Services</h1>
          <div className="servicesAccent" aria-hidden="true" />
          <p className="servicesText">
            Our values and discipline vaulted us to the top of our industry.
          </p>

          <div className="servicesTriWrap">
            <div className="servicesTriGrid">
              <TriCard
                title="Core Planning"
                iconSrc={icon1}
                iconAlt="Core Planning icon"
                desc="We lay the groundwork for success through meticulous core planning, analyzing every detail, aligning with client goals, and setting a clear path for efficient and cost-effective project execution."
              />
              <TriCard
                title="Sustainable Designs"
                iconSrc={icon2}
                iconAlt="Traditional Designs icon"
                desc="Our projects use sustainable materials that reduce environmental impact while ensuring strength, safety, and lasting quality, specified for structural performance, durability, and lifecycle efficiency standards.."
              />
              <TriCard
                title="Sustainable Materials"
                iconSrc={icon3}
                iconAlt="Quality Materials icon"
                desc="Our sustainable designs unite aesthetics and performance through smart planning and energy-efficient solutions, creating durable, eco-conscious spaces that optimize comfort, efficiency, and long-term environmental value."
              />
            </div>

            {/* ✅ Construction Services Slider */}
            <ConstructionServicesGallery />
          </div>
        </div>
      </div>

      {/* =========================
          SECTION 3: STATS + VIDEO + PROVIDE GRID
         ========================= */}
      <section className="servicesStatsSection">
        <div className="servicesInner">
          <div className="servicesStatsHeader">
            <p className="servicesStatsKicker">OUR IMPACT</p>
            <h2 className="servicesStatsTitle">Built on Experience</h2>
            <div className="servicesStatsLine" aria-hidden="true" />
          </div>

          <div className="servicesStatsGrid">
            <ServicesStatsCard
              big="5+"
              label="YEARS"
              sub="Professional Experience"
            />
            <ServicesStatsCard
              big="56"
              label="PEOPLE"
              sub="Employees in team"
              center
            />
            <ServicesStatsCard
              big="18+"
              label="LOCATIONS"
              sub="Sites in development"
            />
          </div>

          {/* ✅ WHAT WE PROVIDE */}
          <div
            className="servicesProvideBlock"
            aria-label="What we provide section"
          >
            <img
              src={faviconIbs}
              alt="IBS favicon"
              className="servicesProvideLogo"
              loading="lazy"
            />
            <div className="servicesProvideKicker">WHAT WE PROVIDE</div>
            <div className="servicesProvideTitle">Exclusive Services</div>

            <div
              className="servicesProvideGrid"
              role="list"
              aria-label="Exclusive services list"
            >
              {provideServices.map((item) => (
                <ProvideCard
                  key={item.title}
                  title={item.title}
                  desc={item.desc}
                  iconSrc={item.icon}
                  iconAlt={`${item.title} icon`}
                />
              ))}
            </div>

            {/* ✅ IMAGE LEFT + CONTENT RIGHT */}
            <div className="servicesProvideAfter" aria-label="Connect section">
              <div className="servicesProvideAfterMedia">
                <img
                  src={servicesImg}
                  alt="Construction site"
                  className="servicesProvideAfterImg"
                  loading="lazy"
                />
                <div
                  className="servicesProvideAfterOverlay"
                  aria-hidden="true"
                />
                <span
                  className="servicesProvideAfterGlow"
                  aria-hidden="true"
                />
              </div>

              <div className="servicesConnectContent">
                <h3 className="servicesConnectTitle">
                  Ready to work together?
                </h3>

                <p className="servicesConnectDesc">
                  Whether you need a trusted construction partner
                  <br />
                  or a new career opportunity, let’s connect!
                </p>

                <a className="servicesConnectBtn" href="/contact">
                  Build a Project →
                </a>

                <div className="servicesConnectPulse" aria-hidden="true" />
              </div>
            </div>
            {/* ✅ END */}
          </div>
        </div>
      </section>
    </section>
  );
}

/* =========================
   CONSTRUCTION SERVICES SLIDER
   ========================= */
function ConstructionServicesGallery() {
  const slides = useMemo(
    () => [
      {
        title: "General Contracting",
        subtitle:
          "One of the most critical stages of the construction process is the commissioning and closeout.",
        image: generalImg,
        alt: "General contracting service",
      },
      {
        title: "Construction Consultant",
        subtitle:
          "One of the most critical stages of the construction process is the commissioning and closeout.",
        image: constructionImg,
        alt: "Construction consultant service",
      },
      {
        title: "Metal Roofing",
        subtitle:
          "One of the most critical stages of the construction process is the commissioning and closeout.",
        image: metalImg,
        alt: "Metal roofing service",
      },
      {
        title: "House Renovation",
        subtitle:
          "One of the most critical stages of the construction process is the commissioning and closeout.",
        image: houseImg,
        alt: "House renovation service",
      },
      {
        title: "Green Building",
        subtitle:
          "One of the most critical stages of the construction process is the commissioning and closeout.",
        image: greenImg,
        alt: "Green building service",
      },
    ],
    []
  );

  const [active, setActive] = useState(0);
  const [prevActive, setPrevActive] = useState(0);
  const [direction, setDirection] = useState("next");
  const [isHover, setIsHover] = useState(false);

  const intervalRef = useRef(null);
  const reduceMotionRef = useRef(false);

  useEffect(() => {
    reduceMotionRef.current =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }, []);

  const goTo = (idx, dirOverride) => {
    const nextIdx = (idx + slides.length) % slides.length;
    if (nextIdx === active) return;

    setPrevActive(active);

    if (dirOverride) {
      setDirection(dirOverride);
    } else {
      const forward = (nextIdx - active + slides.length) % slides.length;
      const backward = (active - nextIdx + slides.length) % slides.length;
      setDirection(forward <= backward ? "next" : "prev");
    }

    setActive(nextIdx);
  };

  const next = () => goTo(active + 1, "next");
  const prev = () => goTo(active - 1, "prev");

  useEffect(() => {
    if (isHover) return;

    if (intervalRef.current) clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      setPrevActive(active);
      setDirection("next");
      setActive((a) => (a + 1) % slides.length);
    }, 1200);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isHover, slides.length, active]);

  const current = slides[active];
  const previous = slides[prevActive];

  const motionClass = reduceMotionRef.current
    ? "isReduced"
    : direction === "prev"
      ? "isPrevDir"
      : "isNextDir";

  return (
    <section
      className="csgSection"
      aria-label="Construction Services"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className="csgShell csgShellV2">
        {/* LEFT: BIG IMAGE */}
        <div className={`csgMedia ${motionClass}`}>
          <div className="csgMediaPane">
            {/* previous */}
            <div className="csgLayer csgMediaLayer isLeaving" aria-hidden="true">
              <img
                src={previous.image}
                alt=""
                className="csgMediaImg"
                loading="lazy"
              />
            </div>

            {/* active */}
            <div className="csgLayer csgMediaLayer isActive">
              <img
                src={current.image}
                alt={current.alt}
                className="csgMediaImg"
                loading="lazy"
              />
            </div>

            <div className="csgMediaOverlay" aria-hidden="true" />
            <div className="csgMediaBadge" aria-hidden="true">
              CONSTRUCTION SERVICES
            </div>
          </div>
        </div>

        {/* RIGHT: GLASS TEXT CARD */}
        <div className="csgInfo">
          <div className="csgInfoHead">
            <h2 className="csgTitle">Construction Services</h2>
            <div className="csgLine" aria-hidden="true" />
          </div>

          <div className={`csgInfoBody ${motionClass}`} aria-live="polite">
            {/* leaving */}
            <div
              className="csgLayer csgTextLayer isLeaving"
              aria-hidden={prevActive === active}
            >
              <span className="srOnly">
                Slide {prevActive + 1} of {slides.length}
              </span>
              <h3 className="csgServiceTitle">{previous.title}</h3>
              <p className="csgServiceSubtitle">{previous.subtitle}</p>
            </div>

            {/* active */}
            <div className="csgLayer csgTextLayer isActive">
              <span className="srOnly">
                Slide {active + 1} of {slides.length}
              </span>

              <h3 className="csgServiceTitle">{current.title}</h3>
              <p className="csgServiceSubtitle">{current.subtitle}</p>

              <div className="csgControls" aria-label="Slideshow controls">
                <button
                  type="button"
                  className="csgArrow"
                  onClick={prev}
                  aria-label="Previous service"
                >
                  ‹
                </button>

                <div
                  className="csgDots"
                  role="tablist"
                  aria-label="Service navigation dots"
                >
                  {slides.map((_, i) => (
                    <button
                      key={i}
                      type="button"
                      className={`csgDot ${i === active ? "isActive" : ""}`}
                      onClick={() => goTo(i)}
                      aria-label={`Go to slide ${i + 1}`}
                      aria-pressed={i === active}
                    />
                  ))}
                </div>

                <button
                  type="button"
                  className="csgArrow"
                  onClick={next}
                  aria-label="Next service"
                >
                  ›
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function TriCard({ title, desc, iconSrc, iconAlt }) {
  return (
    <article className="servicesTriCard">
      <div className="servicesTriTopAccent" aria-hidden="true" />
      <div className="servicesTriIconBox">
        <img
          className="servicesTriIconImg"
          src={iconSrc}
          alt={iconAlt}
          loading="lazy"
        />
      </div>
      <h3 className="servicesTriTitle">{title}</h3>
      <div className="servicesTriBodyPanel">
        <p className="servicesTriDesc">{desc}</p>
      </div>
    </article>
  );
}

function ProvideCard({ title, desc, iconSrc, iconAlt }) {
  return (
    <article className="servicesProvideCard" role="listitem">
      <div className="servicesProvideContent">
        <h3 className="servicesProvideCardTitle">{title}</h3>
        <p className="servicesProvideCardDesc">{desc}</p>
      </div>

      <div className="servicesProvideFooter" aria-hidden="true">
        <div className="servicesProvideIconPlate">
          <img
            src={iconSrc}
            alt={iconAlt}
            className="servicesProvideIconImg"
            loading="lazy"
          />
        </div>
      </div>
    </article>
  );
}

function ServicesStatsCard({ big, label, sub, center }) {
  return (
    <article className={`servicesStatNeo ${center ? "servicesStatNeoCenter" : ""}`}>
      <div className="servicesStatNeoTop" aria-hidden="true" />
      <div className="servicesStatNeoCorner" aria-hidden="true" />
      <div className="servicesStatNeoGrid">
        <div className="servicesStatNeoNum">{big}</div>
        <div className="servicesStatNeoRight">
          <div className="servicesStatNeoChip">{label}</div>
          <p className="servicesStatNeoSub">{sub}</p>
        </div>
      </div>
    </article>
  );
}
